<template lang="pug">
v-card.access-item(elevation=0 outlined :to="item.route")
  v-container.fill-height(fluid)
    v-card-text.card-text
      v-row(no-gutters)
        v-col
          v-row(justify="center" align="center")
            component.function-icon(:is="item.icon.value" v-if="item.icon.type === 'internal'" )
            v-icon.function-icon.mb-1(v-else) {{item.icon.value}}
          v-row(v-if="item.parentMenu" justify="center" align="center")
            span.parent-menu-text {{ item.parentMenu }}
          v-row(justify="center" align="center" )
            span.function-text {{ item[`${title}`] }}
</template>

<script>
export default {
  name: "QuickAcessItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: "name",
    },
  },
  computed: {
    getHeight() {
      return this.isMobile ? "150px" : "400px";
    },
    getWidth() {
      return this.isMobile ? "100%" : "306px";
    },
  },
};
</script>

<style lang="sass" scoped>
.parent-menu-text
  color: var(--v-homeQuickAccessFunctionsParentMenu-base)
  font-size: 15px
  // color: gray
  text-align: center

.container .fill-height
  align-items: center

.access-item
  align-items: center
  background-color: var(--v-cardBackground-base)
  width: 250px !important
  height: 250px !important

.access-item:hover
  border: 2px solid var(--v-primary-base)
  cursor: pointer
  .function-icon
    color: var(--v-primary-base)
    fill: var(--v-primary-base)

  .function-text
    color: var(--v-primary-base)

.function-icon
  fill: var(--v-homeQuickAccessFunctions-base)
  color: var(--v-homeQuickAccessFunctions-base)
  font-size: 100px
  width: 150px
  height: 100px

.function-text
  font-size: 18px
  line-height: 27px
  text-align: center

@media #{map-get($display-breakpoints, 'lg-only')}
  .access-item
    width: 250px !important
    height: 250px !important

@media #{map-get($display-breakpoints, 'lg-and-down')}
  .function-text
    font-size: 16px
    line-height: 25px

  .parent-menu-text
    font-size: 12px

@media #{map-get($display-breakpoints, 'md-and-down')}
  .access-item
    width: 200px !important
    height: 200px !important

@media #{map-get($display-breakpoints, 'xs-only')}
  .card-text
    padding: 0px

  .function-icon
    padding-bottom: 12px
    font-size: 55px
    width: 75px
    height: 75px

  .function-text
    font-size: 14px
    line-height: 21px

  .parent-menu-text
    margin-top: -8px
    font-size: 12px

  .access-item
    width: 300px !important
    height: 150px !important
</style>
